import { render, staticRenderFns } from "./MarketingCard.vue?vue&type=template&id=25c20c00"
import script from "./MarketingCard.vue?vue&type=script&lang=js"
export * from "./MarketingCard.vue?vue&type=script&lang=js"
import style0 from "./MarketingCard.vue?vue&type=style&index=0&id=25c20c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports